import styles from './Landing.module.scss';
import Header from '../common/Header';
import { Link } from 'react-router-dom';
import MainLogo from '../../assets/images/main_logo.png';
import TheoriginLogo from '../../assets/images/theorigin_logo.png';
import MainCherry1 from '../../assets/images/main_cherry_1.png';
import MainCherry2 from '../../assets/images/main_cherry_2.png';
import SloganText from '../../assets/images/slogan_text.png';
import Feature1 from '../common/Feature1';
import Feature2 from '../common/Feature2';
import Feature3 from '../common/Feature3';
import Feature4 from '../common/Feature4';

const Landing = () => {
  return (
    <div className={styles.wrapper}>
      <Header />

      <div className={styles.container}>
        <div className={styles.background}>
          <div className={styles.main_container}>
            <img src={MainCherry1} alt="main" className={styles.main_cherry} />
            <img src={MainLogo} alt="main" className={styles.main_logo} />
            <img src={MainCherry2} alt="main" className={styles.main_cherry} />
          </div>
          <div className={styles.main_slogan}>
            {/* <p
              className={styles.slogan}
              data-text="한 층 한 층 쌓이는 설렘, 파르페"
            >
              한 층 한 층 쌓이는 설렘, 파르페
            </p> */}
            <img src={SloganText} alt="slogan" />
          </div>
        </div>
        <Feature1 />
        <Feature2 />
        <Feature3 />
        <Feature4 />
        <div className={styles.footer}>
          <div className={styles.footer_left}>
            <div className={styles.footer_row}>
              <button
                className={styles.footer_logo}
                onClick={() => {
                  window.open('https://theorigin.kr', '_blank');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                }}
              >
                <img src={TheoriginLogo} alt="logo" />
              </button>
            </div>
            <div className={styles.footer_row}>
              <div
                className={styles.footer_text}
                style={{
                  cursor: 'pointer',
                  textDecorationLine: 'underline',
                  color: 'rgba(255,255,255,1)',
                }}
              >
                <a href="/terms.html">이용약관</a>
              </div>
              <div
                className={styles.footer_text}
                style={{
                  cursor: 'pointer',
                  textDecorationLine: 'underline',
                  color: 'rgba(255,255,255,1)',
                }}
              >
                <a href="/privacy-policy.html">개인정보처리방침</a>
              </div>
              <div
                className={styles.footer_text}
                style={{
                  cursor: 'pointer',
                  textDecorationLine: 'underline',
                  color: 'rgba(255,255,255,1)',
                }}
              >
                <Link to="mailto:support@theorigin.kr" target="_blank">
                  CONTACT
                </Link>
              </div>
            </div>
            <div className={styles.footer_row}>
              <div className={styles.footer_text}>
                225, 80-90, UN village-gil, Yongsan-gu, Seoul, Korea
              </div>
            </div>
            <div className={styles.footer_row}>
              <div className={styles.footer_text}>
                © The Origin Inc. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
